import {useBoolean} from '@huse/boolean';

type BooleanHooks = [boolean, () => void, () => void, (arg: unknown) => void];

export default (initialValue: boolean = false): BooleanHooks => {
    const [value, {on, off, toggle}] = useBoolean(initialValue);

    return [value, on, off, toggle];
};